import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import JobInsights from './views/pages/JobInsights.vue';
import ReactionOverview from "./views/pages/ReactionOverview.vue";

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home'
    },
    {
        path: '/insights',
        name: 'job-insights',
        component: JobInsights,
        meta: {
            title: "Job Inzichten",
        },
        alias: '/job-insights',
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'job-insights-form',
                components: {
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    },
                },
            },
        ],
    },
    {
        path: '/reaction-overview/:hashId',
        name: 'reaction-overview',
        component: ReactionOverview,
        meta: {
            title: "Reaction overview",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'reaction-overview-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },

];


routes = Vue.cmsRouter.setRoutes(routes);

const router = new VueRouter({
    routes
})

Vue.cmsRouter.setActiveRouter(router);

export default router;
